import { PackageType } from "@/__generated__/globalTypes"
import ModuleSection from "@/components/auth/ModuleSection"
import useAuth from "@/components/auth/useAuth"
import DropdownMenu from "@/components/util/menu/DropdownMenu"
import MODULE_TYPES from "@/constants/MODULE_TYPES"
import { Button, ListItemIcon, makeStyles, MenuItem } from "@material-ui/core"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import BusinessIcon from "@material-ui/icons/Business"
import EqualizerIcon from "@material-ui/icons/Equalizer"
import GroupIcon from "@material-ui/icons/Group"
import LocalATMIcon from "@material-ui/icons/LocalAtm"
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import DetermineBaseRouteByOrganisationCategory from "../common/shared/DetermineBaseRouteByOrganisationCategory"

const useStyles = makeStyles(theme => ({
  markets: {
    fontSize: 12,
    paddingLeft: theme.spacing(1)
  }
}))
type MarketsMenuProps = {
  module:
    | MODULE_TYPES.MANAGER
    | MODULE_TYPES.CONSULTANT
    | MODULE_TYPES.OWNER
    | MODULE_TYPES.CASH_MANAGEMENT
}

export default function MarketsMenu(props: MarketsMenuProps) {
  const { user } = useAuth()

  const orgCategory =
    user?.organisation?.organisationType.organisationCategory.name
  const baseRoute = DetermineBaseRouteByOrganisationCategory(
    orgCategory || "client"
  )

  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <PopupState variant="popover" popupId="reports">
      {popupState => (
        <React.Fragment>
          <Button color="inherit" {...bindTrigger(popupState)}>
            <EqualizerIcon />
            <span className={classes.markets}>{t("Markets")}</span>
            <ArrowDropDownIcon />
          </Button>
          <DropdownMenu {...bindMenu(popupState)}>
            <ModuleSection
              module={[
                MODULE_TYPES.MANAGER,
                MODULE_TYPES.OWNER,
                MODULE_TYPES.CASH_MANAGEMENT
              ]}
              organisationPackage={PackageType.securities}
              userPackage={PackageType.securities}
            >
              <MenuItem
                component={Link}
                to={`/${baseRoute}/securities`}
                onClick={popupState.close}
              >
                <ListItemIcon>
                  <BusinessIcon />
                </ListItemIcon>
                {t("Securities")}
              </MenuItem>
            </ModuleSection>
            <ModuleSection
              module={[MODULE_TYPES.MANAGER, MODULE_TYPES.OWNER]}
              organisationPackage={PackageType.fxrates}
              userPackage={PackageType.fxrates}
            >
              <MenuItem
                component={Link}
                to={`/${baseRoute}/fx`}
                onClick={popupState.close}
              >
                <ListItemIcon>
                  <LocalATMIcon />
                </ListItemIcon>
                {t("Foreign Exchange")}
              </MenuItem>
            </ModuleSection>
            <ModuleSection module={MODULE_TYPES.CASH_MANAGEMENT}>
              <MenuItem
                component={Link}
                to={`/${baseRoute}/counterparties`}
                onClick={popupState.close}
              >
                <ListItemIcon>
                  <GroupIcon />
                </ListItemIcon>
                {t("Counterparties")}
              </MenuItem>
            </ModuleSection>
          </DropdownMenu>
        </React.Fragment>
      )}
    </PopupState>
  )
}
